import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useFraudTypeDetail } from './hook';
import { FraudTypeData } from './data';
import { FraudTypeParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    FRAUD_TYPE_NEW,
    FRAUD_TYPE,
    FRAUD_TYPE_EDIT,
    FRAUD_TYPE_DETAIL,
} from '../../../../../routes/paths';
import { FraudTypeRegisterHistory } from './registerHistory';

export const FraudTypeDetail = () => {
    const {
        fraudType,
        fraudTypeHistorical,
        showHistorical,
        setShowHistorical,
    } = useFraudTypeDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle tipología de fraude"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={fraudType?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_TYPE,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: FRAUD_TYPE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FRAUD_TYPE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(fraudType?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <FraudTypeParamsHistorical
                            historical={fraudTypeHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <FraudTypeData data={fraudType} />
                </LayoutModule>
            </LayoutModule>
            <FraudTypeRegisterHistory fraudType={fraudType} />
        </>
    );
};
